import css from "styled-jsx/css";

export default css`
  .my-data-fake {
    display: flex;
    flex-direction: column;
    margin-bottom: 3rem;
    &--name {
      height: 20px;
      width: 50%;
    }
    &--profile-data {
      display: flex;
      align-items: center;
      &--icon {
        aspect-ratio: 1 / 1;
        width: 90px;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #019df4;
        border-radius: 50%;
        margin-right: 1.5rem;
      }
    }
    &--box {
      display: flex;
      flex-wrap: wrap;
      padding-top: 2rem;
    }
    &--title {
      height: 20px;
      width: 33%;
    }
  }

  .info-box-fake {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 0 1.5rem 0;
  }

  @media (min-width: 768px) {
    .info-box-fake {
      width: 50%;
      padding: 0 2.5rem 0 0;
    }
  }
`;
